import { useEffect } from 'react';

import { storeRwgReferral } from '@m/utils/rwgConversion';

import type { RwgConfig } from '@m/utils/rwgConversion';

/**
 * Shared core of Reserve with Google token capture. Router-agnostic on purpose: the customer app
 * reads the params from react-router and the marketing app from `next/navigation`, but both must
 * persist them identically.
 */
export function useStoreRwgReferral(
  token: string | undefined,
  referredZone: string | undefined,
  config: RwgConfig,
): void {
  useEffect(() => {
    if (!token) {
      return;
    }
    storeRwgReferral({ token, referredZone }, config);
  }, [token, referredZone, config]);
}
